
import { getBadgeIcon } from '@/utils/badgeIcons'

// 任务 code → 徽章族 code：同一能力线的任务，名行右端放对应族图标；无对应族 → 不放
const TASK_BADGE = {
  admin_product_image: 'badge_image_master',
  admin_inspection: 'badge_inspection_master',
  operator_inspection: 'badge_inspection_master',
  admin_assign: 'badge_dispatch_master',
  courier_deliver: 'badge_delivery_master',
  user_browse: 'badge_explorer'
}

// 徽章族 code → 展示名（与服务端 taskService 族名同源）：标题升为「今日任务·族名」
const TASK_BADGE_NAME = {
  badge_image_master: '图传能手',
  badge_inspection_master: '验货达人',
  badge_dispatch_master: '调度能手',
  badge_delivery_master: '配送达人',
  badge_explorer: '探索者'
}

// 每日任务卡。数据来自 /api/growth/summary 的 dailyTask DTO（camelCase），
// 组件纯展示不改数据；EXP 飞行动画由 Center 编排（起点=本卡 $el）。
export default {
  name: 'DailyTaskCard',
  props: {
    task: { type: Object, required: true }
  },
  computed: {
    // 任务行右端徽章族图标（无映射任务返回空串 → 不渲染）
    taskBadgeIcon () {
      return getBadgeIcon(TASK_BADGE[this.task.code] || '')
    },
    // 标题：任务有徽章族映射 → 「今日任务·族名」；无映射保持纯「今日任务」
    titleText () {
      const fam = TASK_BADGE[this.task.code]
      const nm = fam && TASK_BADGE_NAME[fam]
      return nm ? `今日任务·${nm}` : '今日任务'
    },
    // 单段任务（模板 1/1/1）：与多阶段共用版式，只在奖励文案上合并三段（§5.2）
    isSingleEvent () {
      return this.task.stage1Target === this.task.stage3Target
    },
    // 单段任务三段 EXP 合并展示为一个完成奖励
    totalExp () {
      return (this.task.stage1Exp || 0) + (this.task.stage2Exp || 0) + (this.task.stage3Exp || 0)
    },
    // 进行中辅助说明：多阶段=下一阶段激励；单段=完成奖励合计（§10 文案）
    hintText () {
      if (this.isSingleEvent) return `完成奖励 +${this.totalExp} EXP`
      return `再完成 ${this.nextNeed} 个，完成本阶段 +${this.currentExp} EXP`
    },
    // 当前阶段 = 第一个未结算阶段；全部结算 → 任务完成（§9 累计进度，一次事件可跨多段）
    currentStage () {
      const r = this.task.stageRewarded || []
      for (let i = 0; i < 3; i++) {
        if (!r[i]) return i + 1
      }
      return 3
    },
    isDone () {
      const r = this.task.stageRewarded || []
      return !!(r[0] && r[1] && r[2])
    },
    currentTarget () {
      return this.task['stage' + this.currentStage + 'Target']
    },
    currentExp () {
      return this.task['stage' + this.currentStage + 'Exp']
    },
    nextNeed () {
      return Math.max(0, this.currentTarget - this.task.progress)
    },
    // 当前阶段内进度条（阶段1: 0→t1；阶段2: t1→t2；阶段3: t2→t3）
    stagePercent () {
      const prev = this.currentStage > 1 ? this.task['stage' + (this.currentStage - 1) + 'Target'] : 0
      const span = this.currentTarget - prev
      if (span <= 0) return 100
      return Math.min(100, Math.max(0, ((this.task.progress - prev) / span) * 100))
    },
    // 完成态「已完成 N 个」：封顶计到 stage3 目标，超额部分由额外行单独表达（§6）
    doneCount () {
      return Math.min(this.task.progress, this.task.stage3Target)
    },
    overtimeDone () {
      return Math.max(0, this.task.progress - this.task.stage3Target)
    },
    overtimeExp () {
      return (this.task.overtimeRewardedUnits || 0) * (this.task.overtimeExpPerUnit || 0)
    }
  }
}
